export default __webpack_public_path__ + "assets/38ab48c56769befcfd156ac8b2246255.png";